// import CONS from 'x/config/constants'
import { IApiOptions, ICrmChannel } from 'x/types'
import api from './api'

type IGetCrmChannelListRequestBody = {
  store_id: number
}

type ICrmChannelListResponse = {
  crm_channels: ICrmChannel[]
}

export async function getCrmChannelList(params: IGetCrmChannelListRequestBody): Promise<ICrmChannelListResponse> {
  const { store_id } = params
  if (!store_id) {
    throw new Error('getCrmChannelList:: Need store_id')
  }

  const apiOptions: IApiOptions = {
    showSpinner: true,
    // messages: {
    //   successMsg: 'ดึงข้อมูล CRM สำเร็จ',
    //   errorMsg: 'ดึงข้อมูล CRM ล้มเหลว กรุณาลองกดใหม่อีกครั้ง',
    // },
    axiosOptions: {
      timeout: 60000,
    },
    isApiV2: true,
  }

  const reqBody: IGetCrmChannelListRequestBody = {
    store_id,
  }

  try {
    const res = await api.post<IGetCrmChannelListRequestBody, ICrmChannelListResponse>('crm/channel/list', reqBody, apiOptions)
    return res
  } catch (err) {
    console.log('getCrmChannelList:: err => ', err)
    throw err
  }
}

type IGetCrmChannelDetailRequestBody = {
  store_id: number
  crm_channel_id: number
}

type ICrmChannelDetailResponse = {
  crm_channel: ICrmChannel
}

export async function getCrmChannelDetail(params: IGetCrmChannelDetailRequestBody): Promise<ICrmChannelDetailResponse> {
  const { store_id, crm_channel_id } = params
  if (!store_id) {
    throw new Error('getCrmChannelDetail:: Need store_id')
  }
  if (!crm_channel_id) {
    throw new Error('getCrmChannelDetail:: Need crm_channel_id')
  }

  const apiOptions: IApiOptions = {
    showSpinner: true,
    axiosOptions: {
      timeout: 60000,
    },
    isApiV2: true,
  }

  const reqBody: IGetCrmChannelDetailRequestBody = {
    store_id,
    crm_channel_id,
  }

  try {
    const res = await api.post<IGetCrmChannelDetailRequestBody, ICrmChannelDetailResponse>('crm/channel/detail', reqBody, apiOptions)
    return res
  } catch (err) {
    console.log('getCrmChannelDetail:: err => ', err)
    throw err
  }
}

type IDeleteCrmChannelRequestBody = {
  store_id: number
  crm_channel_id: number
}

type IDeleteCrmChannelResponse = {
  status: 'ok'
}

export async function deleteCrmChannel(params: IDeleteCrmChannelRequestBody): Promise<boolean> {
  const { store_id, crm_channel_id } = params
  if (!store_id) {
    throw new Error('deleteCrmChannel:: Need store_id')
  }
  if (!crm_channel_id) {
    throw new Error('deleteCrmChannel:: Need crm_channel_id')
  }

  const apiOptions: IApiOptions = {
    showSpinner: true,
    messages: {
      successMsg: 'ลบช่องทางสำเร็จ',
      errorMsg: 'ลบช่องทางล้มเหลว กรุณาลองกดใหม่อีกครั้ง',
    },
    axiosOptions: {
      timeout: 60000,
    },
    isApiV2: true,
  }

  const reqBody: IDeleteCrmChannelRequestBody = {
    store_id,
    crm_channel_id,
  }

  try {
    const res = await api.post<IDeleteCrmChannelRequestBody, IDeleteCrmChannelResponse>('crm/channel/delete', reqBody, apiOptions)
    if (res && res.status === 'ok') {
      return true
    }
  } catch (err) {
    console.log('deleteCrmChannel:: err => ', err)
    throw err
  }

  return false
}

interface IUpdateCrmChannelRequestBody extends Partial<ICrmChannel> {
  store_id: number
  crm_channel_id: number
}

export async function updateCrmChannel(params: IUpdateCrmChannelRequestBody): Promise<ICrmChannelDetailResponse> {
  const { store_id, crm_channel_id } = params
  if (!store_id) {
    throw new Error('updateCrmChannel:: Need store_id')
  }
  if (!crm_channel_id) {
    throw new Error('updateCrmChannel:: Need crm_channel_id')
  }

  const apiOptions: IApiOptions = {
    showSpinner: true,
    messages: {
      successMsg: 'แก้ไขข้อมูลสำเร็จ',
      errorMsg: 'แก้ไขข้อมูลล้มเหลว กรุณาลองกดใหม่อีกครั้ง',
    },
    axiosOptions: {
      timeout: 60000,
    },
    isApiV2: true,
  }

  const reqBody: IUpdateCrmChannelRequestBody = {
    ...params,
  }

  try {
    const res = await api.post<IUpdateCrmChannelRequestBody, ICrmChannelDetailResponse>('crm/channel/update', reqBody, apiOptions)
    return res
  } catch (err) {
    console.log('updateCrmChannel:: err => ', err)
    throw err
  }
}

// example data
// "store_id":3,
// "name": "Test Create Deepblok Channel",
// "client_code": "MOCKUP00208",
// "key_code": "UATNANTEGLOBAL",
// "hash_key": "M8CF/abcde=",
// "brand_code": "UAT",
// "system_brand_name": "MOCKUP"
interface ICreateCrmChannelWithDeepblokRequestBody {
  store_id: number
  name: string
  client_code: string
  key_code: string
  hash_key: string
  brand_code: string
  system_brand_name: string
}

export async function createCrmChannelWithDeepblok(params: ICreateCrmChannelWithDeepblokRequestBody): Promise<ICrmChannelDetailResponse> {
  const { store_id } = params
  if (!store_id) {
    throw new Error('createCrmChannelWithDeepblok:: Need store_id')
  }

  const apiOptions: IApiOptions = {
    showSpinner: true,
    messages: {
      successMsg: 'สร้างช่องทางสำเร็จ',
      errorMsg: 'สร้างช่องทางล้มเหลว กรุณาลองกดใหม่อีกครั้ง',
    },
    axiosOptions: {
      timeout: 60000,
    },
    isApiV2: true,
  }

  const reqBody: ICreateCrmChannelWithDeepblokRequestBody = {
    ...params,
  }

  try {
    const res = await api.post<ICreateCrmChannelWithDeepblokRequestBody, ICrmChannelDetailResponse>(
      'crm/channel/deepblok/create',
      reqBody,
      apiOptions
    )
    return res
  } catch (err) {
    console.log('createCrmChannelWithDeepblok:: err => ', err)
    throw err
  }
}
